import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { Toastr, tools } from 'data/common';
import {
    FHEContainerForm,
    FHEContainerScroll,
    FHETitle,
    FHETextField,
    FormEditButton,
    FormSaveButton,
    FormButtonContainer,
    SubMenuVertical,
} from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import { Map } from 'immutable';
import { SvgManagement, SvgUser } from 'data/common/iconsvg';
import Management from '../sections/Managements';
import UserManager from '../sections/UsersManagers';

class FormBrand extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        sendDataFunc: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
        brand: PropTypes.object,
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        const { type } = props;
        console.log(props.match.params.brandId, 'EYOOOO')
        this.state = {
            formDisabled: type === 'update',
            brandForm: this.getDataForm(),
            textInput_error: {},
            sendLoading: false,
            tabList: {
                details: {
                    label: Translator.translate('general.Residences'),
                    Icon: SvgManagement,
                    View: () => <Management brandId={props.match.params.brandId} />,
                    right: 'homeList',
                },
                users: {
                    label: Translator.translate('general.Users'),
                    Icon: SvgUser,
                    View: () => <UserManager brandId={props.match.params.brandId} />,
                    right: `homeList`,
                },
            },
        };
    }

    getDataForm = () => {
        const { type, brand } = this.props;
        return {
            title: type === 'update' ? brand.get('title') : null,
        };
    };

    loadInputs = () => {
        this.setState({
            formDisabled: true,
            sendLoading: false,
            brandForm: this.getDataForm(),
        });
    };

    handleEdit = () => {
        const { formDisabled } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: formDisabled ? true : !formDisabled,
            textInput_error: {},
        });
    };

    handleChange = event => {
        const { brandForm, textInput_error } = this.state;
        const fieldLengthRules = {
            title: 255,
            key: 15,
            short_key: 10,
        };
        const value = tools.maxFieldLength(fieldLengthRules, brandForm, event.target);

        this.setState({
            brandForm: { ...brandForm, [event.target.name]: value },
            textInput_error: tools.removeKey(textInput_error, event.target.name),
        });
    };

    handleReactSelect = (event, options) => {
        const { brandForm, textInput_error } = this.state;

        const newTextInput_error = tools.removeKey(textInput_error, options.name);

        this.setState({
            brandForm: { ...brandForm, [options.name]: event.value },
            textInput_error: newTextInput_error,
        });
    };

    confirmEdit = () => {
        const { brandForm } = this.state;
        const { sendDataFunc } = this.props;
        if (this.validateForm(brandForm)) {
            this.setState({
                sendLoading: true,
                formDisabled: true,
            });
            return sendDataFunc(brandForm)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.brand.actions.editBrandSuccess`, brandForm.title));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        sendLoading: false,
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false,
                    });
                    Toastr.error(`generic.brand.actions.editBrandError`, brandForm.title);
                    if (error.validation && error.validation.errors) {
                        return this.setState({
                            textInput_error: tools.handleFormError(error.validation.errors),
                        });
                    }
                });
        }
    };

    validateForm = form => {
        const arrayCheckEmptyFields = ['title'];
        const errors = tools.checkEmptyFields(form, arrayCheckEmptyFields);
        this.setState({
            textInput_error: errors,
        });

        return Object.keys(errors).length <= 0;
    };

    saveBrand = () => {
        const { brandForm } = this.state;
        const { sendDataFunc, history } = this.props;

        if (this.validateForm(brandForm)) {
            this.setState({
                formDisabled: true,
                sendLoading: true,
            });
            return sendDataFunc(brandForm)
                .then(data => {
                    const brand = data.brand;
                    Toastr.success(Translator.translate('generic.brand.actions.addUserManagerSuccess', brand.lastname, brand.firstname));
                    return history.push(`/${history.environment}/user-manager`);
                })
                .catch(error => {
                    Toastr.error(Translator.translate('generic.brand.actions.addUserManagerError', brandForm.firstname, brandForm.lastname));
                    this.setState({
                        formDisabled: false,
                        sendLoading: false,
                    });
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors);
                    }
                });
        }
    };

    // renders
    renderButtons() {
        const { formDisabled, sendLoading } = this.state;
        const { type } = this.props;
        if (type === 'update') {
            return (
                <FormEditButton formDisabled={formDisabled} handleEdit={this.handleEdit} confirmEdit={this.confirmEdit} sendLoading={sendLoading} />
            );
        } else {
            return <FormSaveButton sendFunc={this.saveBrand} sendLoading={sendLoading} />;
        }
    }

    render() {
        const { textInput_error, formDisabled, brandForm, sendLoading, tabList } = this.state;
        const { brand, type } = this.props;

        return (
            <Fragment>
                <FHETitle
                    title={type === 'update' ? `${brand.get('title')}` : Translator.translate('general.addBrand')}
                    Icon={() => <BookmarkIcon fontSize="large" />}
                />
                <FormButtonContainer sendLoading={sendLoading} buttons={this.renderButtons()} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="title"
                                    value={brandForm.title}
                                    error={textInput_error.title}
                                    label={Translator.translate('general.table.column.title')}
                                    name="title"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    <SubMenuVertical tabList={tabList} childRef={ref => (this.refSubmenu = ref)} />
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const brand = state.environments[history.environment].data.Brands.getIn(['list', props.match.params.brandId], new Map());

    return {
        brand,
    };
}

export default withRouter(renderEnvComponent('scenes/Brands/components/Form/FormBrand', connect(mapStateToProps)(FormBrand)));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Brands/components/Form/FormBrand.js